import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const ProtectedRoute = ({ children, allowedGroups }) => {
  const { user, isAuthenticated, isLoadingAuth } = useAuth();
  const location = useLocation();
  const userGroups = user?.signInUserSession?.accessToken?.payload['cognito:groups'] || [];
  
  if (isLoadingAuth) {
    return <div className="loading">Verificando autenticação...</div>;
  }

  if (!isAuthenticated) {
    // console.log('ProtectedRoute: Not authenticated, saving path:', location.pathname);
    localStorage.setItem('lastPath', location.pathname);
    return null;
  }
  
  if (!allowedGroups.some(group => userGroups.includes(group))) {
    // console.log('ProtectedRoute: Not authorized for this route.');
    return <Navigate to="/" replace />;
  }
  
  // console.log('ProtectedRoute: Authorized, rendering children for path:', location.pathname);
  return children;
};

export default ProtectedRoute; 